// extracted by mini-css-extract-plugin
module.exports =  {"features-list":"_7506d987b5--features-list--qOTEF","two-lines":"_7506d987b5--two-lines--Zdcwc","feature-title":"_7506d987b5--feature-title--hB_QN"};